import Header from "../components/Header";
import PrivacyContent from "../components/PrivacyContent";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-20 pb-16 px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-funnel text-4xl font-semibold text-foreground mb-8">
            Privacy Policy
          </h1>
          <div className="text-muted-foreground mb-6">
            Last updated: 13 April 2026
          </div>
          <div className="text-lg">
            <PrivacyContent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
